<script setup lang="ts">
import { $t } from "~/utils/index.js";
import { onMounted, onUnmounted, ref } from 'vue'

defineProps({
  src: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
  alt: {
    type: String,
    default: '',
  },
  fit: {
    type: String,
    
  },
})

const imageRef = ref(null)
const isIntersecting = ref(false)

let observer

onMounted(() => {
  observer = new IntersectionObserver(observerCallback, {
    rootMargin: '50px',
  })
  if (imageRef.value) {
    observer.observe(imageRef.value)
  }
})

function observerCallback(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      isIntersecting.value = true
      observer.unobserve(entry.target)
    }
  })
}

function handleLoad() {
  if (observer && imageRef.value) {
    observer.unobserve(imageRef.value)
  }
}

function handleError() {
  // imageRef.value.src = ''
}

onUnmounted(() => {
  if (observer && imageRef.value) {
    observer.unobserve(imageRef.value)
  }
})
</script>

<template>
  <div class="lazy-image">
    <img
      ref="imageRef"
      :style="{
        opacity:isIntersecting?1:0,
      }"
      :src="isIntersecting ? src : placeholder"
      :alt="alt"
      :fit="fit"
      referrerpolicy="no-referrer"
      class="lazy-image__img"
      @load="handleLoad"
      @error="handleError"
    >
    <div v-if="!isIntersecting" class="lazy-image__placeholder">
      <slot name="placeholder">
        <div class="placeholder-content">
        
        </div>
      </slot>
    </div>
  </div>
</template>

<style scoped>
.lazy-image {
  position: relative;
}
.lazy-image__img {
  display: block;
  width: 100%;
  height: 100%;
}
.lazy-image__placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.placeholder-content {
  color: #999;
  font-size: 14px;
}
</style>
